import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Pocket = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Pocket' {...props}>
    <g fill='none' fillRule='evenodd'><path fill='#F50057' d='M12,2 L2,2 C0.8954305,2 0,2.8954305 0,4 C0,7 0,9 0,12 C0,17.9821415 6,23 12,23 C18,23 24,17.9821415 24,12 C24,9 24,7 24,4 C24,2.8954305 23.1045695,2 22,2 L12,2 Z' /><polyline stroke='#FFF' strokeLinecap='round' strokeLinejoin='round' strokeWidth='3' points='6 9 12.404 15 18 9' /></g>
  </StyledIcon>
);
